import { useBookingModuleStore, useCalendarRoot } from "PFApp/booking/store";
import { CalendarRoot } from "PFApp/booking/types/calendar_root";
import { isWorkforceProfiles } from "PFApp/booking/utils/calendar_root.utils";
import {
  AVAILABILITY_SCOPE_LIMIT,
  hasReachedLimit
} from "PFApp/components/filters/filter_items/availability_filter/helpers";
import { useFiltersBufferState, useFiltersV2Select } from "PFApp/components/filters_v2";
import { useTranslation } from "react-i18next";

export const useIsBookingCategoryFilterDisabled = () => {
  const { searchId } = useFiltersV2Select("searchId");
  const { isFiltersBufferDirty } = useFiltersBufferState();
  const { isAutoRefreshOn } = useFiltersV2Select("isAutoRefreshOn");
  const { t } = useTranslation("bookingModule");

  const calendarRoot = useCalendarRoot();
  const filteredProfilesCount = useBookingModuleStore((state) =>
    isWorkforceProfiles(calendarRoot)
      ? state[CalendarRoot.WorkforceProfiles]?.counters?.filteredProfilesCount
      : null
  );

  const isDisabled =
    !searchId ||
    hasReachedLimit(filteredProfilesCount ?? Infinity) ||
    (!isAutoRefreshOn && isFiltersBufferDirty);

  const getMessage = () => {
    if (!isDisabled) {
      return "";
    }
    if (hasReachedLimit(filteredProfilesCount ?? Infinity)) {
      return t("bookings.tooltip.tooManyWorkforceMembers", { count: AVAILABILITY_SCOPE_LIMIT });
    }
    return t("bookings.tooltip.filtersNotApplied");
  };

  return { isDisabled, message: getMessage() };
};
